"use client";

import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import HubspotEmbed from "@/components/forms/hubspot-embed";
import HubspotFormDisclaimer from "@/components/forms/disclaimer/hubspot-form-disclaimer";
import {ColletteIconButton} from "@collette-travel/collette-common-controls";
import {Close} from "@mui/icons-material";
import ViewBrochureOnlineFormSkeleton
  from "@/components/forms/view-brochure-online/view-brochure-online-form.skeleton";

interface ViewBrochureOnlineFormProps {
  formId: string;
  formTitle: string;
  dataLayerProps: Record<string, any> | null;
  isLoading: boolean;
  handleClose: () => void;
  targetId?: string;
}

const ViewBrochureOnlineForm = ({
  formId,
  formTitle,
  dataLayerProps,
  isLoading,
  handleClose,
  targetId
}: ViewBrochureOnlineFormProps) => (
    <Stack
      sx={{
        backgroundColor: "background.default",
        padding: "4rem 4rem 2rem",
        gap: "2.4rem"
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      >
        <Typography
          component="p"
          variant="h5"
          data-testid="view-brochure-online-header"
        >
          {formTitle}
        </Typography>
        <ColletteIconButton
          testId="view-brochure-online-close-button"
          onClick={handleClose}
          sx={{
            mt: "-0.8rem",
            mr: "-0.8rem"
          }}
        >
          <Close />
        </ColletteIconButton>
      </Stack>
      <Box
        sx={{
          width: "100%",
          display: isLoading ? "auto" : "none"
        }}
      >
        <ViewBrochureOnlineFormSkeleton />
      </Box>
      <Box
        sx={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in"
        }}
      >
        <HubspotEmbed
          formId={formId}
          dataLayerProps={dataLayerProps}
          targetId={targetId}
        />
      </Box>
      <HubspotFormDisclaimer testId="view-brochure-online-form-disclaimer" />
    </Stack>
  );

export default ViewBrochureOnlineForm;